import React, { useState } from "react";
import { Button, Box, Grid, Typography, Container } from "@mui/material";
import styles from "./manage-OrgTransactions.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { useFetchData } from "../../../helper/helperFunction";
import AdminApi from "../../../config/apis/admin";
import Moment from "react-moment";
import { limitStringLength } from "../../../helper/helperFunction";
import GlobalModal from "../../../components/modalBox";
import {HasPermission} from '../../../helper/helperFunction'

const formatAmount = (value) =>
  value === null || value === undefined || isNaN(value)
    ? "0.00"
    : Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });


export const DetailsOrgBanner = ({
  formSuccess,
  setModalOpen,
  tittle,
  showBar,
  amoutBox
}) => {
  const params = useParams();
  const nevigate = useNavigate();

  const [orgTransactionData, setOrgTransactionData] = useState({
    organization_name: "",
    description: "",
    created_at: "",
    total: null,
    used: null,
    remaining: null,
  });

  const {
    organization_name,
    description,
    created_at,
    total,
    used,
    remaining,
    currency_symbol,
  } = orgTransactionData;

  const usedPercent =
    Number(total) > 0
      ? Math.min(100, Math.max(0, (Number(used) / Number(total)) * 100))
      : 0;

  const handleFetchSuccess = (data) => {
    setOrgTransactionData(data);
  };

  const handleFetchError = (error) => {
    console.error(error);
  };

  // Use the custom hook to fetch data
  useFetchData(
    params.id ?? "",
    handleFetchSuccess,
    handleFetchError,
    AdminApi.ORGANIZATION_DETAIL,
    formSuccess
  );

  const viewHistory = async () => {
    nevigate(`/admin/org-history/view/${params.id}`);
  };

  const [readOpen, setReadOpen] = useState(false);
  const handleCloseModal = () => {
    setReadOpen(false);
  };
  return (
    <>
      <Container maxWidth="xl" className={styles.transactionsDetail}>
        <Grid container marginTop={12}>
          <Typography variant="h1" component="h1" className={styles.heading}>
            {tittle ?? ""}
          </Typography>
          <Grid container className={styles.gradientBackground}>
            <Grid item xs={12}>
              <Grid container marginTop={1}>
                <Typography
                  variant="body1"
                  component="sapn"
                  className={styles.transactionsId}
                >
                  {orgTransactionData && organization_name}
                </Typography>
              </Grid>
              <Grid container>
                <Grid
                  xs={8}
                  item
                  container
                  className={styles.infoWrap}
                  justifyContent={"space-between"}
                >
                  <Box className={styles.borderLeft}>
                    <Typography
                      variant="body1"
                      component="p"
                      className={styles.email}
                    >
                      Description
                    </Typography>
                    <Typography
                      variant="body1"
                      component="p"
                      className={styles.emailAdress}
                      maxWidth={700}
                    >
                      {orgTransactionData && limitStringLength(description, 150)}
                    </Typography>

                    {orgTransactionData && description.length > 55 ? (
                      <Typography
                        variant="body1"
                        component="span"
                        // maxWidth={400}
                        sx={{
                          color: "#fff",
                          textAlign: "right",
                          display: "block",
                          fontSize: "15px",
                          cursor: "pointer",
                        }}
                        onClick={() => setReadOpen(true)}
                      >
                        Readmore
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Box>

                  <Box className={styles.borderLeft}>
                    <Typography
                      variant="body1"
                      component="p"
                      className={styles.email}
                    >
                      Added On
                    </Typography>
                    <Typography
                      variant="body1"
                      component="p"
                      className={styles.emailAdress}
                    >
                      <Moment format="DD/MM/YYYY  hh:mmA">
                        {orgTransactionData && created_at}
                      </Moment>
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={4}
                  container
                  justifyContent={"flex-end"}
                  alignContent={"flex-start"}
                >
                  <Box className={styles.fundSummaryCard}>
                    <Typography
                      variant="body1"
                      component="p"
                      className={styles.fundSummaryLabel}
                    >
                      {amoutBox ?? "Amount"}
                    </Typography>
                    <Box className={styles.fundTotalWrap}>
                      <Typography
                        variant="body1"
                        component="span"
                        className={styles.fundCurrency}
                      >
                        {currency_symbol}
                      </Typography>
                      <Typography
                        variant="body1"
                        component="span"
                        className={styles.fundTotalValue}
                      >
                        {formatAmount(total)}
                      </Typography>
                    </Box>

                    <Box className={styles.fundProgressTrack}>
                      <Box
                        className={styles.fundProgressFill}
                        sx={{ width: `${usedPercent}%` }}
                      />
                    </Box>

                    <Box className={styles.fundRow}>
                      <Typography
                        variant="body1"
                        component="span"
                        className={styles.fundRowLabel}
                      >
                        Used
                      </Typography>
                      <Typography
                        variant="body1"
                        component="span"
                        className={styles.fundRowValue}
                      >
                        {currency_symbol} {formatAmount(used)}
                      </Typography>
                    </Box>
                    <Box className={styles.fundRow}>
                      <Typography
                        variant="body1"
                        component="span"
                        className={styles.fundRowLabel}
                      >
                        Remaining
                      </Typography>
                      <Typography
                        variant="body1"
                        component="span"
                        className={`${styles.fundRowValue} ${styles.fundRowValueRemaining}`}
                      >
                        {currency_symbol} {formatAmount(remaining)}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {showBar ? (
            ""
          ) : (
            <Grid
              container
              justifyContent={"space-between"}
              marginTop={4}
              sx={{ padding: "0 30px" }}
            >
              <HasPermission permission="manage-organization-transactions.view">
                <Box
                  className={styles.buttonWrap}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Typography
                    variant="body1"
                    component="h2"
                    className={styles.fundHeading}
                  >
                    Fund Transactions
                  </Typography>
                </Box>
                </HasPermission>
              <Box className={styles.buttonWrap}>
                <HasPermission permission="manage-organization-transactions.view">
                <Button
                  onClick={() => {
                    viewHistory();
                  }}
                >
                  View History
                </Button>
                </HasPermission>
                <HasPermission permission="manage-organization-transactions.create">
                    <Button
                      className={styles.buttonRed}
                      onClick={() => {
                        setModalOpen(true);
                      }}
                      >
                      Add Transaction
                    </Button>
                </HasPermission>
              </Box>
            </Grid>
          )}
        </Grid>
      </Container>

      <GlobalModal open={readOpen} onClose={handleCloseModal} width={619}>
        {orgTransactionData && description}
      </GlobalModal>
    </>
  );
};
